import React, { Suspense } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { CAlert, CContainer, CFade } from "@coreui/react";
import { useSelector } from "react-redux";
import { RootState } from "../../store";

// routes config
import routes from "../../routes";

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

// Only super users reach a suspended company; they are reminded of it.
const SuspensionNotice = () => {
  const suspension = useSelector(
    (state: RootState) => state.taxPayer.data.taxPayer.suspension,
  );

  if (!suspension) {
    return null;
  }

  return (
    <CAlert color="danger" className="mb-2">
      <strong>Empresa suspendida</strong>
      {suspension.reasonName ? ` por ${suspension.reasonName}` : ""}. Sus
      usuarios no tienen acceso; usted la ve como super usuario.
    </CAlert>
  );
};

const Content = () => {
  let routeComponents: React.ReactElement[] = [];
  for (const key in routes) {
    const route = routes[key];
    routeComponents.push(
      <Route
        key={key}
        path={route.path}
        exact={route.exact}
        render={(props) => (
          <CFade>
            <route.component {...props} />
          </CFade>
        )}
      />
    );
  }
  return (
    <main className="c-main" style={{ paddingTop: "10px" }}>
      <CContainer fluid style={{ paddingLeft: "10px", paddingRight: "10px" }}>
        <SuspensionNotice />
        <Suspense fallback={loading}>
          <Switch>
            {routeComponents}
            <Redirect from="/" to="/dashboard" />
          </Switch>
        </Suspense>
      </CContainer>
    </main>
  );
};

export default React.memo(Content);
